// Load optional enhancements only when their markup exists. Observe added
// subtrees so filters, quick add and the theme editor get the same behaviour.
const configuration = document.getElementById('theme-optional-components');
const pending = new Map(Object.entries(JSON.parse(configuration?.textContent || '{}')));
const loading = new Set();

function scan(root) {
  if (!(root instanceof Element || root instanceof Document)) return;
  for (const [selector, url] of pending) {
    if (loading.has(selector)) continue;
    if (!(root instanceof Element && root.matches(selector)) && !root.querySelector(selector)) continue;
    loading.add(selector);
    import(url).then(() => {
      pending.delete(selector);
      if (!pending.size) observer.disconnect();
    }).catch((error) => {
      // Allow a subsequent insertion to retry a failed network request.
      loading.delete(selector);
      console.error('[theme] Could not load optional component:', selector, error);
    });
  }
}

const observer = new MutationObserver((records) => {
  const roots = new Set();
  for (const record of records) {
    for (const node of record.addedNodes) {
      if (node instanceof Element) roots.add(node);
    }
  }
  for (const root of roots) {
    // A parent's subtree already includes any separately reported children.
    if (root.isConnected && ![...roots].some((other) => other !== root && other.contains(root))) scan(root);
  }
});
observer.observe(document.documentElement, { childList: true, subtree: true });
scan(document);
